// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Theme__Color$PrezzeeRibbon from "../../../theme/Theme__Color.bs.js";

var backgroundColor = Theme__Color$PrezzeeRibbon.Personal.white;

var Theme_logoBlockMargin = {
  NAME: "rem",
  VAL: 0
};

var Theme = {
  backgroundColor: backgroundColor,
  logoPosition: "center",
  logoBlockMargin: Theme_logoBlockMargin
};

export {
  Theme ,
}
/* Theme__Color-PrezzeeRibbon Not a pure module */
